export default __webpack_public_path__ + "static/media/success.77b0dadd.svg";